<template>
  <base-dialog-adm    width="700px"
                      :show="true"
                      :tempSaveBtn="false"
                      title="地址資料"
                      @close="closeDialog"
                      @save="commitDialog"
                      >

    <validation-observer ref="observer">
      <base-box>
      <v-container grid-list-md>
        <v-layout row
                    wrap
                    class="form">
          <v-flex sm4>
            <sub-header class="required">
              <template v-slot:title>縣市</template>
            </sub-header>
            <b-auto-or-select v-model="address.addrCity"
                              s-tag="autocomplete"
                              :items="cityList"
                              item-text="cityName"
                              item-value="cityName"
                              :search-input.sync="addrCitySync"
                              label="縣市"
                              vid="addrCity"
                              @change="cityNameChange"
                              mode="lazy"></b-auto-or-select>
          </v-flex>
        </v-layout>

        <v-layout row
                    wrap
                    class="form">
          <v-flex sm6>
            <sub-header class="required">
              <template v-slot:title>區域</template>
            </sub-header>
            <b-auto-or-select v-model="addrAreaObj"
                              s-tag="autocomplete"
                              :items="areaItems"
                              return-object
                              item-text="areaNameCode"
                              :search-input.sync="addrAreaSync"
                              @input="areaNameInput"
                              label="行政區"
                              vid="addrArea"
                              @change="areaNameChange"
                              mode="lazy"></b-auto-or-select>
          </v-flex>
        </v-layout>

        <v-layout row
                    wrap
                    class="form">
          <v-flex sm12>
            <sub-header class="required">
              <template v-slot:title>路名</template>
            </sub-header>
            <b-auto-or-select v-model="address.addrRoad"
                              s-tag="autocomplete"
                              :items="roadItems"
                              item-text="roadName"
                              return-object
                              :search-input.sync="addrRoadSync"
                              @input="roadNameInput"
                              label="路名"
                              vid="addrRoad"
                              mode="lazy"></b-auto-or-select>
          </v-flex>

          <v-flex sm12>
            <span class="required">地址明細</span>
            {{ addressMemo }}
          </v-flex>
        </v-layout>

        <v-layout row
                    wrap
                    class="form">

          <v-flex sm12>
            <input v-model="address.addrLane"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrLane = halfToFullAddrLane(address.addrLane)"
                          />巷
            <input v-model="address.addrAlley"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrAlley = halfToFullAddrNum(address.addrAlley)"
                          />弄
            <input v-model="address.addrLon"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrLon = halfToFullNum(address.addrLon)"
                          />衖
            <input v-model="address.addrNum"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrNum = halfToFullAddrNum(address.addrNum)"
                          />號之
            <input v-model="address.addrNumOf"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrNumOf = halfToFullNum(address.addrNumOf)"
                          />
          </v-flex>
        </v-layout>

        <v-layout row
                    wrap
                    class="form">

            <v-flex sm3>
              <v-select v-model="address.addrFloor"
                                :items="floorList"
                                item-text="codeName"
                                item-value="codeName"
                                clearable
                                label=""
                                menu-props="auto"
                                outline></v-select>
            </v-flex>
            <v-flex sm9 style="margin-left: 0px;">
              樓之<input v-model="address.addrFloorOf"
                          style="max-width: 100px;width: 100px"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrFloorOf = halfToFullNum(address.addrFloorOf)"
                          />
            <input v-model="address.addrRoom"
                          style="max-width: 100px;width: 100px;margin-left: 20px;"
                          class="bi-input"
                          placeholder=""
                          maxlength="10"
                          @blur="address.addrRoom = halfToFull(address.addrRoom)"
                          />室

          </v-flex>

          <v-flex sm12>
            <template v-if="address.refAddress">
              (由保經業管系統或證券開戶資料帶入參考: {{ address.refAddress }})
            </template>
          </v-flex>
        </v-layout>
      </v-container>
      </base-box>
    </validation-observer>
  </base-dialog-adm>
</template>
<script>
import { halfFull } from '@/mixin'
import {
  filter,
  orderBy
} from 'lodash'
import addressApi from '@/components/Ins/Policy/AddressApi.js'
import { createNamespacedHelpers } from 'vuex'
const { mapActions: commonMapActions } = createNamespacedHelpers('common')
const {
  mapGetters: commonMapGetters
} = createNamespacedHelpers('common')
export default {
  name: 'select-address',
  mixins: [halfFull, addressApi],
  props: {
    propAddr: Object
  },
  data () {
    return {
      addrAreaObj: {},
      roadItems: [],
      address: {
        type: '', // R: 戶藉地址, L: 住所地址
        transCode: '',
        compCode: '',
        addrCity: '', // 縣市
        addrArea: '', // 區域
        addrZipCode: '', // 郵遞區號
        addrRoad: '', // 路名
        addrLane: '', // 巷
        addrAlley: '', // 弄
        addrLon: '', // 衖
        addrNum: '', // 號
        addrNumOf: '', // 號之
        addrFloor: '', // 樓
        addrFloorOf: '', // 樓之
        addrRoom: '', // 室
        // refAddress: '(由保經業管系統或證券開戶資料帶入參考: 臺北市中正區八德踏一段１０巷１８弄３號)',
        refAddress: ''
      },
      addressMemo: '（例：xx巷xx弄xx之xx號xx樓之xx；無衖請不填，xx號只能打數字或中間加「之」或「-」）',
      addrCitySync: null,
      addrAreaSync: null,
      addrRoadSync: null,
      insAddrCheckYn: '' // add for SCR #96622 , 地址正規化開關 (ADM_PARMD-S01)
    }
  },
  watch: {
    propAddr: {
      handler (v) {
        this.address = { ...this.propAddr }
        this.addrAreaObj.areaName = this.address.addrArea
        this.addrAreaObj.zipCode = this.address.addrZipCode
        this.addrAreaObj.areaNameCode = this.address.addrArea + ' ' + this.address.addrZipCode

        if (!(this.address.addrFloor)) {
          this.address.addrFloor = '一'
        }
      },
      immediate: true,
      deep: true
    },
    addrCitySync (v) {
      if (!v) {
        this.address.addrCity = ''
        this.address.addrArea = ''
        this.address.addrZipCode = ''
        this.address.addrRoad = ''
      }
    },
    addrAreaSync (v) {
      if (!v) {
        this.address.addrArea = ''
        this.address.addrZipCode = ''
        this.address.addrRoad = ''
      }
    },
    addrRoadSync (v) {
      if (!v) {
        this.address.addrRoad = ''
      }
    }
  },
  computed: {
    ...commonMapGetters([
      'cityList',
      'areaMap'
    ]),
    areaItems () {
      if (this.address.addrCity) {
        let areaItems = this.areaMap[this.address.addrCity] || []
        areaItems.forEach(e => {
          e.areaNameCode = e.areaName + ' ' + e.zipCode
        })
        return orderBy(areaItems, 'zipCode')
      }
      return []
    },
    floorList () {
      let list = this.$store.getters['common/admCodeDetail']({
        codeType: 'FLOOR_CODE'
      })
      return orderBy(list, 'showOrder')
    },
  },
  created () {

  },
  mounted () {
    this.fetchRoadItems()
  },
  methods: {
    ...commonMapActions(['fetchRoadName','fetchSingleParam' ]),
    cityNameChange () {
      this.address.addrArea = ''
      this.address.addrZipCode = ''
      this.address.addrRoad = ''
    },
    getAjaxInsAddrCheckYn() { //fix: SCR #96622 ，調整 [地址檢核開關] 參數抓取方式
      return this.fetchSingleParam({ type :'INS', code: "INS_ADDR_CHECK_YN" }).then(r =>{
        this.insAddrCheckYn = r.data.parameterValue // 地址檢核開關 參數
      })
    },
    areaNameInput (v) {
      if (v && v.areaName) {
        this.address.addrArea = v.areaName
        this.address.addrZipCode = v.zipCode
        this.address.addrRoad = ''
      }
      if (!v) {
        this.address.addrArea = ''
        this.address.addrZipCode = ''
        this.address.addrRoad = ''
      }
    },
    areaNameChange () {
      this.fetchRoadItems()
    },
    fetchRoadItems () {
      if (this.address.addrCity && this.address.addrArea) {
        let vm = this
        this.fetchRoadName({
          cityName: this.address.addrCity,
          areaName: this.address.addrArea
        }).then(r => {
          vm.roadItems = r.data
        })
      }
      this.roadItems = []
    },
    roadNameInput (v) {
      if (v && v.roadName) {
        this.address.addrRoad = v.roadName
      }
    },
    closeDialog () {
      this.$emit('close')
    },
    hasStatusCode13 (v) {
      if (!(v.resultAnalysis && v.resultAnalysis.statusCode && v.resultAnalysis.statusCode.length > 0)) {
        return false
      }
      let flag = false
      v.resultAnalysis.statusCode.forEach(e => {
        if (e === 13) {
          flag = true
        }
      })
      return flag
    },
    commitDialog () { //fix: SCR #96622 ，調整 [地址檢核開關] 參數抓取方式
      this.getAjaxInsAddrCheckYn().then(() => {
        this.commitDialogInner()
      })
    },
    commitDialogInner () {
      if (!this.address.addrCity) {
        this.$alert('請填寫 縣市!')
        return
      }
      if (!this.address.addrArea) {
        this.$alert('請填寫 區域!')
        return
      }
      if (!this.address.addrRoad) {
        this.$alert('請填寫 路名!')
        return
      }
      if (!this.address.addrLane && !this.address.addrAlley && !this.address.addrLon && !this.address.addrNum &&
        !this.address.addrNumOf && !this.address.addrFloor && !this.address.addrFloorOf) {
        this.$alert('地址明細，至少需填寫一個欄位!')
        return
      }
      if (!this.address.addrNum && this.address.addrNumOf) {
        this.$alert('地址明細，號填寫不完全，請重新填寫!')
        return
      }
      if (!this.address.addrFloor && this.address.addrFloorOf) {
        this.$alert('地址明細，樓填寫不完全，請重新填寫!')
        return
      }

      this.$emit('confirmlog')

      let test = false
      if (test) {
        this.$emit('commit', this.address)
        return
      }
      if ('N' === this.insAddrCheckYn) {// fix: SCR #96622 ,根據 地址檢核開關(「地址正規化開關」) 流程調整
        this.$emit('commit', this.address)
        return
      }
      let vm = this
      this.addressCheck(this.getFullAddress(this.address), this.address.transCode, this.address.compCode).then(r => {
        if (r.connectError) {
          vm.address.connectError = r.connectError
          vm.$alert('地址正規化檢核連線失敗!，關閉訊息後將直接填入您輸入的地址', () => {
            vm.$emit('commit', vm.address)
          })
        } else if (r.code === 'ok1') {
          vm.address.addrCity = r.address.addrCity
          vm.address.addrArea = r.address.addrArea
          vm.address.addrZipCode = r.address.addrZipCode
          vm.addrAreaObj.areaName = vm.address.addrArea
          vm.addrAreaObj.zipCode = vm.address.addrZipCode
          vm.addrAreaObj.areaNameCode = vm.address.addrArea + ' ' + vm.address.addrZipCode
          vm.roadItems = []
          /*
          vm.fetchRoadName({
            cityName: r.address.addrCity,
            areaName: r.address.addrArea
          }).then(r2 => {
            vm.roadItems = r2.data
            vm.$nextTick(() => {
              setTimeout(() => {
                vm.address = Object.assign(vm.address, r.address)
                vm.$emit('commit', vm.address)
              }, 1000)
            })
          })
          */
          vm.$nextTick(() => {
            setTimeout(() => {
              vm.address = Object.assign(vm.address, r.address)
              vm.$emit('commit', vm.address)
            }, 1000)
          })

          return
        } else if (r.code === 'ok2') {
          const msg =  r.msg + ((vm.address.addrRoom)?(' ' + vm.address.addrRoom+'室'):'') + ' 請確認'
          vm.$alert(msg)
          vm.address.addrCity = r.address.addrCity
          vm.address.addrArea = r.address.addrArea
          vm.address.addrZipCode = r.address.addrZipCode
          vm.addrAreaObj.areaName = vm.address.addrArea
          vm.addrAreaObj.zipCode = vm.address.addrZipCode
          vm.addrAreaObj.areaNameCode = vm.address.addrArea + ' ' + vm.address.addrZipCode
          vm.roadItems = []
          /*
          vm.fetchRoadName({
            cityName: r.address.addrCity,
            areaName: r.address.addrArea
          }).then(r2 => {
            vm.roadItems = r2.data
            vm.$nextTick(() => {
              setTimeout(() => {
                vm.address = Object.assign(vm.address, r.address)
                vm.$emit('commit', vm.address)
              }, 1000)
            })
          })
          */
          vm.$nextTick(() => {
            setTimeout(() => {
              vm.address = Object.assign(vm.address, r.address)
              vm.$emit('commit', vm.address)
            }, 1000)
          })


          return
        } else {
          this.$alert(r.msg)
          return
        }

      })

    }
  }
}
</script>
<style lang="stylus" scoped>

.title-name {
  font-size: $font-size-ml;
  font-weight: bold;
  letter-spacing: 1.2px;
  margin-top: 30px;
  text-align: left;
}


</style>
